import React, { createContext, useContext } from 'react';
import { usePerformedSearchRequest } from 'clientState/providers/SearchRequestProvider';
import { useFilterState } from './StateProvider';

const PredicateContext = createContext();

const alwaysTrue = () => true;

const createSegmentPredicate =
  ({ carriers }) =>
  (segment) =>
    carriers.some(
      (carrier) => carrier.checked && carrier.id === segment.carrier.id
    );

const createRoundTripPredicates = (filterRequest) => {
  const predicate = createSegmentPredicate(filterRequest[0]);
  return [predicate, predicate];
};

const createItineraryPredicate = (filterRequest, tripType) => {
  if (!filterRequest) {
    return alwaysTrue;
  }
  const segmentPredicates =
    tripType === 'ROUND_TRIP'
      ? createRoundTripPredicates(filterRequest)
      : filterRequest.map(createSegmentPredicate);
  return ({ legs }) => {
    return legs.every((leg, index) =>
      segmentPredicates[index](leg.segments[0])
    );
  };
};

export const usePredicate = () => useContext(PredicateContext);

export default function PredicateProvider({ children }) {
  const carriers = useFilterState();
  const { tripType } = usePerformedSearchRequest() || {};
  const carrierPredicate = createItineraryPredicate(carriers, tripType);
  return (
    <PredicateContext.Provider value={carrierPredicate}>
      {children}
    </PredicateContext.Provider>
  );
}
